import Vue from 'vue';
import Router, {NavigationGuard} from 'vue-router';

import HomePage from '@/containers/account/home/home.vue';
import SpikePage from '@/containers/account/spike/spike-page.vue';

import NewsContainer from '@/containers/account/news/news-container.vue';
import NewsEditPage from '@/containers/account/news/news-edit.vue';
import AlertsEditPage from '@/containers/account/news/alerts-edit.vue';

import OfficesMasterPage from '@/containers/account/offices/offices-master.vue';

import AgentsMasterPage from '@/containers/account/agents/agents-master.vue';
import AgentsEditComponent from '@/containers/account/agents/agents-edit.vue';

import AdminsMasterPage from '@/containers/account/admins/admins-master.vue';
import AdminsEditComponent from '@/containers/account/admins/admins-edit.vue';
import MigrationPage from '@/containers/account/migration/migration.vue';

import AgentsAppoveComponent from '@/containers/account/agents/agents-approve.vue';

import OfficesEditComponent from '@/containers/account/offices/offices-edit.vue';
import LoginLogsMasterPage from '@/containers/account/login-logs/login-logs-master.vue';
import LoginPage from '@/containers/login/login-page.vue';
import ForgotPage from '@/containers/forgot/forgot-page.vue';
import Account from '@/containers/account/account.vue';
import LogsContainer from '@/containers/account/logs/logs-container.vue';
import store from '@/store/store';
import * as types from '@/store/types';

import RemoteLogin from '@/containers/remote-login.vue';

import SitesContainer from '@/containers/account/sites/sites-container.vue';
import SitesMasterPage from '@/containers/account/sites/sites-master.vue';
import SitesEditComponent from '@/containers/account/sites/sites-edit.vue';
import AgentOfficeSiteComponent from '@/containers/account/sites/agent-office-sites.vue';

import ProfilePage from '@/containers/account/profile/profile.vue';
import ChatLogsMasterPage from '@/containers/account/chat-logs/chat-logs-master.vue';
import ChatLogsSubmit from '@/containers/account/chat-logs/chat-logs-submit.vue';

import SiteManualsMasterPage from '@/containers/account/site-manuals/site-manuals-master.vue';
import SiteManualsEditPage from '@/containers/account/site-manuals/site-manuals-edit.vue';
import SiteManualsView from '@/containers/account/site-manuals/site-manuals-view.vue';

import SiteTypesMasterPage from '@/containers/account/site-types/site-types-master.vue';
import SiteTypesEditPage from '@/containers/account/site-types/site-types-edit.vue';

import ClickOutsMasterPage from '@/containers/account/click-outs/click-outs-master.vue';

import SaleLogsMasterPage from '@/containers/account/sale-logs/sale-logs.vue';

import GenerateLinksPage from '@/containers/account/links/generate-links.vue';

import CompanyFees from '@/containers/account/company-fees/company-fees.vue';

// Stats

import StatsContainer from '@/containers/account/stats/stats-container.vue';
import Top10Agents from '@/containers/account/stats/top10-agents.vue';
import OfficeProgress from '@/containers/account/stats/office-progress.vue';
import OfficeProgressChart from '@/containers/account/stats/office-progress-chart.vue';
import SitesStats from '@/containers/account/stats/sites-stats.vue';
import SiteAvpStats from '@/containers/account/stats/sites-avp-stats.vue';
import SitesStatsPayout from '@/containers/account/stats/sites-stats-payout.vue';
import SitesAvpStatsPayout from '@/containers/account/stats/sites-avp-stats-payout.vue';
import LinksContainer from '@/containers/account/links/links-container.vue';
import LinksTranslate from '@/containers/account/links/links-translate.vue';
import OfficesContainer from '@/containers/account/offices/offices-container.vue';
import PreferredDomainMasterPage from '@/containers/account/offices/preferred-domain.vue';
import PreferredDomainEditPage from '@/containers/account/offices/preferred-domain-edit.vue';
import IBlackListIpMaster from '@/containers/account/black-list-ip/black-list-ips-master.vue';
import IBlackListIpMasterPage from '@/containers/account/black-list-ip/black-list-ips-master.vue';
import BlackListIpsAdd from '@/containers/account/black-list-ip/black-list-ips-add.vue';
import BlackListIpsDelete from '@/containers/account/black-list-ip/black-list-ips-delete.vue';
import SettingsContainer from '@/containers/account/settings/settings-container.vue';
import Options from '@/containers/account/options/options.vue';
import EditComponent from '@/containers/account/options/options.vue';
import OptionsEditComponent from '@/containers/account/options/options.vue';

Vue.use(Router);

const router = new Router({
    mode: 'history',

    routes: [
        {
            path: '/app',
            component: Account,
            beforeEnter: (to, from, next) => {
                if (store.getters[types.AUTH_GET_IS_LOGGED]) {
                    // todo: check role
                    next();
                } else {
                    next({path: '/login', query: {returnUrl: to.path}});
                }
            },

            children: [
                {
                    path: 'home',
                    component: HomePage
                },
                {
                    path: 'news',
                    component: NewsContainer,
                    children: [
                        {
                            path: '',
                            redirect: 'edit'
                        },
                        {
                            path: 'edit',
                            component: NewsEditPage
                        },
                        {
                            path: 'alerts',
                            component: AlertsEditPage
                        }
                    ]
                },
                {
                    path: 'offices',
                    component: OfficesContainer,
                    // component: OfficesMasterPage
                    children: [
                        {
                            path: '',
                            redirect: 'offices'
                        },
                        {
                            path: 'offices',
                            component: OfficesMasterPage
                        },
                        {
                            path: 'create',
                            component: OfficesEditComponent
                        },
                        {
                            path: 'edit/:id',
                            component: OfficesEditComponent
                        },
                        {
                            path: ':officeId/:name/sites',
                            component: AgentOfficeSiteComponent
                        },
                        {
                            path: 'domains',
                            component: PreferredDomainMasterPage,

                        },
                        {
                            path: 'domains/create',
                            component: PreferredDomainEditPage,
                        },
                        {
                            path: 'domains/:id',
                            component: PreferredDomainEditPage,
                        }
                    ]
                },
                // {
                //     path: 'offices/create',
                //     component: OfficesEditComponent
                // },
                // {
                //     path: 'offices/edit/:id',
                //     component: OfficesEditComponent
                // },
                // {
                //     path: 'offices/:officeId/:name/sites',
                //     component: AgentOfficeSiteComponent
                // },
                {
                    path: 'agents',
                    component: AgentsMasterPage
                },
                {
                    path: 'agents/:agentId/:name/sites',
                    component: AgentOfficeSiteComponent
                },
                {
                    path: 'agents/create',
                    component: AgentsEditComponent
                },
                {
                    path: 'agents/edit/:id',
                    component: AgentsEditComponent
                },
                {
                    path: 'unapprove',
                    component: AgentsAppoveComponent
                },
                {
                    path: 'logs',
                    component: LogsContainer,
                    children: [
                        {
                            path: '',
                            redirect: 'chat'
                        },
                        {
                            path: 'login',
                            component: LoginLogsMasterPage
                        },
                        {
                            path: 'chat',
                            component: ChatLogsMasterPage
                        },
                        {
                            path: 'click-outs',
                            component: ClickOutsMasterPage
                        },
                        {
                            path: 'sale-logs',
                            component: SaleLogsMasterPage
                        }
                    ]
                },
                {
                    path: 'stats',
                    component: StatsContainer,
                    children: [
                        {
                            path: '',
                            redirect: 'sites'
                        },
                        {
                            path: 'top-agents',
                            component: Top10Agents
                        },
                        {
                            path: 'office-performance',
                            component: OfficeProgress
                        },
                        {
                            path: 'office-performance-chart',
                            component: OfficeProgressChart
                        },
                        {
                            path: 'sites',
                            component: SitesStats,
                        },
                        {
                            path: 'sites-avp',
                            component: SiteAvpStats
                        },
                        {
                            path: 'sites-payout',
                            component: SitesStatsPayout
                        },
                        {
                            path: 'sites-payout-avp',
                            component: SitesAvpStatsPayout
                        }
                    ]
                },
                {
                    path: 'chat-logs/create',
                    component: ChatLogsSubmit
                },
                {
                    path: 'sites',
                    component: SitesContainer,
                    children: [
                        {
                            path: '',
                            redirect: 'sites'
                        },
                        {
                            path: 'sites',
                            component: SitesMasterPage
                        },
                        {
                            path: 'company-fees',
                            component: CompanyFees
                        }
                    ]
                },
                {
                    path: 'sites/create',
                    component: SitesEditComponent
                },
                {
                    path: 'sites/edit/:id',
                    component: SitesEditComponent
                },
                {
                    path: 'sites/:siteId/types',
                    component: SiteTypesMasterPage
                },
                {
                    path: 'sites/:siteId/types/create',
                    component: SiteTypesEditPage
                },
                {
                    path: 'sites/:siteId/types/edit/:id',
                    component: SiteTypesEditPage
                },
                {
                    path: 'site-manuals',
                    component: SiteManualsMasterPage
                },
                {
                    path: 'site-manuals/create',
                    component: SiteManualsEditPage
                },
                {
                    path: 'how-to-sell',
                    component: SiteManualsView
                },
                {
                    path: 'site-manuals/edit/:id',
                    component: SiteManualsEditPage
                },
                {
                    path: 'profile',
                    component: ProfilePage
                },
                {
                    path: 'links',
                    component: LinksContainer,
                    children: [
                        {
                            path: '',
                            redirect: 'links'
                        },
                        {
                            path: 'links',
                            component: GenerateLinksPage
                        },
                        {
                            path: 'links-translate',
                            component: LinksTranslate
                        }
                    ]
                },
                // admins
                {
                    path: 'admins',
                    component: AdminsMasterPage
                },
                {
                    path: 'migration',
                    component: MigrationPage
                },
                {
                    path: 'admins/create',
                    component: AdminsEditComponent
                },
                {
                    path: 'admins/edit/:id',
                    component: AdminsEditComponent
                },
                {
                    path: '/spike',
                    component: SpikePage
                },
                {
                    path: 'settings',
                    component: SettingsContainer,
                    children: [
                        {
                            path: '',
                            redirect: 'black-list-ip'
                        },
                        {
                            path: 'black-list-ip',
                            component: IBlackListIpMasterPage
                        },
                        {
                            path: 'black-list-ip',
                            component: IBlackListIpMasterPage
                        },
                        {
                            path: 'black-list-ip/create',
                            component: BlackListIpsAdd
                        },
                        {
                            path: 'black-list-ip/delete',
                            component: BlackListIpsDelete
                        },
                        {
                            path: 'options',
                            component: OptionsEditComponent
                        },
                    ]
                },
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: LoginPage
        },
        {
            path: '/forgot',
            component: ForgotPage
        },
        {
            path: '/remote-login',
            component: RemoteLogin
        },
        {
            path: '*',
            redirect: '/app/home'
        }
    ]
});
router.afterEach((to, from) => {
    const excludePaths: string[] = [
        '/app/stats/sites-avp',
        '/app/stats/sites-payout-avp',
    ];
    if (!to.query.dateRange && !(excludePaths as any).includes(to.path)) {
        store.commit(types.USERDATA_RESET_PERIOD);
    }
});

export default router;
